class CasualMeetingFormCta {
  constructor(selector = 'js-casual-meeting-form-cta') {
    this.selector = selector;
    this.bind();
  }

  bind() {
    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element
        ? event.target.closest(`.${this.selector}`)
        : null;

      if (!target) {
        return;
      }

      const eventName = target.getAttribute('data-ga-event') || '';
      const buttonLocation = target.getAttribute('data-button-location') || '';

      if (!eventName) {
        return;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        button_location: buttonLocation,
      });
    });
  }
}
